const dataOffer = [
  {
    offer: 'FIBRE_VITAL',
    children: [
      {
        technology: 'fibre',
        range: 'vital',
        seo: 'Fibre gamme Vital : ',
        baseline: "Concentré d'essentiel",
      },
    ],
  },
  {
    offer: 'FIBRE_IDEAL',
    children: [
      {
        technology: 'fibre',
        range: 'ideal',
        seo: 'Fibre gamme Idéal : ',
        baseline: 'Le juste équilibre',
      },
    ],
  },
  {
    offer: 'FIBRE_ULTRA',
    children: [
      {
        technology: 'fibre',
        range: 'ultra',
        seo: 'Fibre gamme Ultra : ',
        baseline: 'Confort absolu',
      },
    ],
  },
  {
    offer: 'SAT_VITAL',
    children: [
      {
        technology: 'satellite',
        range: 'vital',
        seo: 'Satellite gamme Vital : ',
        baseline: "Concentré d'essentiel",
      },
    ],
  },
  {
    offer: 'SAT_IDEAL',
    children: [
      {
        technology: 'satellite',
        range: 'ideal',
        seo: 'Satellite gamme Idéal : ',
        baseline: 'Le juste équilibre',
      },
    ],
  },
  {
    offer: 'SAT_ULTRA',
    children: [
      {
        technology: 'satellite',
        range: 'ultra',
        seo: 'Satellite gamme Ultra : ',
        baseline: 'Confort absolu',
      },
    ],
  },
  {
    offer: '4G_VITAL',
    children: [
      {
        technology: '4g',
        range: 'vital',
        seo: '4GFIX gamme Vital : ',
        baseline: "Concentré d'essentiel",
      },
    ],
  },
  {
    offer: '4G_IDEAL',
    children: [
      {
        technology: '4g',
        range: 'ideal',
        seo: '4GFIX gamme Idéal : ',
        baseline: 'Le juste équilibre',
      },
    ],
  },
  {
    offer: '4G_ULTRA',
    children: [
      {
        technology: '4g',
        range: 'ultra',
        seo: '4GFIX gamme Ultra : ',
        baseline: 'Confort absolu',
      },
    ],
  },
  {
    offer: 'SAT_VITAL_PLUS',
    children: [
      {
        technology: '',
        range: 'vital-plus',
        seo: '',
        baseline: 'Concentré d’essentiel',
      },
    ],
  },
  {
    offer: 'SAT_IDEAL_PLUS',
    children: [
      {
        technology: '',
        range: 'ideal-plus',
        seo: '',
        baseline: 'Le juste équilibre',
      },
    ],
  },
  {
    offer: 'SAT_ULTRA_PLUS',
    children: [
      {
        technology: '',
        range: 'ultra-plus',
        seo: '',
        baseline: 'Confort absolu',
      },
    ],
  },
  {
    offer: 'SAT_VITAL_PLUS_LANDING',
    children: [
      {
        technology: '',
        range: 'vital-plus',
        seo: '',
        baseline: 'L’essentiel pour se connecter',
      },
    ],
  },
  {
    offer: 'SAT_IDEAL_PLUS_LANDING',
    children: [
      {
        technology: '',
        range: 'ideal-plus',
        seo: '',
        baseline: 'Connecté, avec un petit plus',
      },
    ],
  },
  {
    offer: 'SAT_ULTRA_PLUS_LANDING',
    children: [
      {
        technology: '',
        range: 'ultra-plus',
        seo: '',
        baseline: 'Connectivité au top, <br />max de services inclus',
      },
    ],
  },
  {
    offer: 'SAT_PRO',
    children: [
      {
        technology: '',
        range: 'neosat-pro',
        seo: '',
        baseline: '',
      },
    ],
  },
  {
    offer: 'SAT_PRO_PLUS',
    children: [
      {
        technology: '',
        range: 'neosat-pro',
        seo: '',
        baseline: '',
      },
    ],
  },
  {
    offer: 'SAT_PRO_PLUS_LANDING',
    children: [
      {
        technology: '',
        range: 'neosat-pro',
        seo: '',
        baseline:
          'Connexion clé en main, <br />services professionnels exclusifs',
      },
    ],
  },
];

export default dataOffer;
